(function () {
  var wrap = document.querySelector('.pts-wrap');
  if (!wrap) return;

  var tabs   = wrap.querySelectorAll('.pts-tab');
  var panels = wrap.querySelectorAll('.pts-panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.dataset.tab;

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-active');
      });

      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');
      var panel = wrap.querySelector('#panel-' + target);
      if (panel) panel.classList.add('is-active');
    });
  });

})();